var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-base-table',{attrs:{"tableOptions":_vm.tableOptions,"displaySettings":false},on:{"re-fetch-data":_vm.fetchData,"re-fetch-paginated-data":function($event){return _vm.fetchData($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }